import { render, staticRenderFns } from "./InventoryReservationIndex.vue?vue&type=template&id=371a9498&scoped=true"
import script from "./InventoryReservationIndex.vue?vue&type=script&lang=js"
export * from "./InventoryReservationIndex.vue?vue&type=script&lang=js"
import style0 from "./InventoryReservationIndex.vue?vue&type=style&index=0&id=371a9498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371a9498",
  null
  
)

export default component.exports